import CardTextData from 'components/molecules/card-text-data'
import PropTypes from 'prop-types'
import React from 'react'
import { Card, CardHeader, CardBody, Col } from 'reactstrap'


const propTypes = {
  orderItem: PropTypes.object
}

/**
 * Display Customer Order item Information
 * @param {object} orderItem - Customer Order Item object
 */
const CustomerOrderItemCard = ({ orderItem }) => (
  <Card>

    <CardHeader>
      <span className="float-left">
        <span className='small text-uppercase font-weight-bolder'>
          { 'Customer Order Item' }
        </span>
      </span>
    </CardHeader>

    <CardBody>
      <Col xs={ 12 } md={ 6 }>
        <CardTextData label='Image' value={ <img style={{ width: '100%' }} src={ orderItem.image } /> } />
        <CardTextData label='SKU' value={ orderItem.sku } />
        <CardTextData label='Name' value={ orderItem.name } />
        <CardTextData label='Quantity' value={ orderItem.quantity } />
      </Col>
    </CardBody>

  </Card>
)

CustomerOrderItemCard.propTypes = propTypes

export default CustomerOrderItemCard
